import { render, staticRenderFns } from "./driverAdd.vue?vue&type=template&id=6a865714&scoped=true"
import script from "./driverAdd.vue?vue&type=script&lang=js"
export * from "./driverAdd.vue?vue&type=script&lang=js"
import style0 from "./driverAdd.vue?vue&type=style&index=0&id=6a865714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a865714",
  null
  
)

export default component.exports